import React from 'react';
import classNames from 'classnames';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';


import * as SeoActions from 'rebook/apps/base/actions/SeoActions';
import * as FaqIndexActions from 'rebook/apps/faq/actions/FaqIndexActions';

import FaqIndexSection from './FaqIndexSection';


const SectionList = ({ sections }) => {
  return (
    sections.length > 0
      ? (
        <ul className="jest-help-questions">
          {sections.map(
            (section) => (
              <FaqIndexSection
                key={section.id}
                name={section.name}
                questionList={section.questions}
                maxInitialQuestionCount={3} />
            )
          )}
        </ul>
      )
      : <div>Нет ни одной секции</div>
  );
};

class FaqIndexView extends React.Component {
  static fetchInitialDataForServer(match, store) {
    return store.dispatch(FaqIndexActions.fetchInitialData());
  }

  componentDidMount() {
    this.props.FaqIndexActions.fetchInitialData();
  }

  componentWillUnmount() {
    this.props.SeoActions.resetData();
  }

  render() {
    const { sections } = this.props.faqIndex;
    return (
      <div className={classNames('backgroundContainer', 'themeGrey')}>
        <div className="col-md-6">
          <h1>Справочный центр</h1>
          <div>
            <p>Ответы на вопросы, которые волнуют читателей</p>
            {sections
              ? (
                <SectionList sections={sections} />
              )
              : (
                <div className="billetContainer">
                  <div className="title-2 elementDummy" />
                  <div className="paragraph elementDummy" />
                  <div className="paragraph elementDummy" />
                  <div className="paragraph elementDummy" />
                </div>
              )
            }
            <div className="tableSummary">
              <small>
                Не нашли ответ? Пожалуйста, напишите в службу поддержки
                по адресу <a href={`mailto:${SUPPORT_EMAIL}`} className="link">{SUPPORT_EMAIL}</a>
              </small>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    faqIndex: state.faqIndex,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    SeoActions: bindActionCreators(SeoActions, dispatch),
    FaqIndexActions: bindActionCreators(FaqIndexActions, dispatch),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(FaqIndexView);
